import { describeSoilAstm } from "./describeSoilAstm";
import { describeSoilIso } from "./describeSoilIso";
import type { SoilDescriptionInputs, SoilDescriptionResult } from "./types";

export function describeSoil(inputs: SoilDescriptionInputs): SoilDescriptionResult | null {
  const fractions = inputs.soilFractions;
  if (!fractions) return null;
  const symbol = inputs.classifiedSoilStandard === fractions.standard ? inputs.classifiedSoil : null;
  switch (fractions.standard) {
    case "ISO":
      return describeSoilIso(fractions, symbol === "CLAY" || symbol === "SILT" ? symbol : null);
    case "ASTM":
      return describeSoilAstm(fractions, symbol === "CLAY" || symbol === "SILT" ? null : symbol);
    default:
      return null;
  }
}
